import { render, staticRenderFns } from "./ScientificDegreeTable.vue?vue&type=template&id=6492ef58&"
import script from "./ScientificDegreeTable.vue?vue&type=script&lang=js&"
export * from "./ScientificDegreeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports